import React from 'react';

import { connect } from "react-redux";

const Part1 = (props) => {

    return (<div>

        <button onClick={() => props.changeIt(props.b + 1)}>change part 2</button>
    </div>);
}

const mapDisparchToProps = (dispatch) => {

    return {
        changeIt: (b) => dispatch({ type: 'updateB', payload: { newb: b } })
    }
}

export default connect(state => state, mapDisparchToProps)(Part1);